var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_3001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.828729 14.0335C0.298259 14.5639 0.000160195 15.2832 0 16.0332L0 17.4849H1.45169C2.20177 17.4848 2.92108 17.1867 3.45139 16.6562L12.8863 7.22129L10.2637 4.59863L0.828729 14.0335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3662 1.11891C16.194 0.946545 15.9895 0.809805 15.7644 0.71651C15.5394 0.623215 15.2981 0.575195 15.0545 0.575195C14.8108 0.575195 14.5696 0.623215 14.3445 0.71651C14.1194 0.809805 13.915 0.946545 13.7428 1.11891L11.2637 3.59874L13.8863 6.2214L16.3662 3.74228C16.5385 3.57009 16.6753 3.36562 16.7686 3.14055C16.8619 2.91548 16.9099 2.67423 16.9099 2.4306C16.9099 2.18696 16.8619 1.94571 16.7686 1.72064C16.6753 1.49557 16.5385 1.2911 16.3662 1.11891Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_3001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9706,
    height: 16.9706,
    fill: "white",
    transform: "translate(0 0.514648)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.2f022fd7eb44915c9b52559f5d4819ee.svg";
export { ForwardRef as ReactComponent };